import { render, staticRenderFns } from "./today-crawler.vue?vue&type=template&id=0c8db79e&scoped=true"
import script from "./today-crawler.vue?vue&type=script&lang=js"
export * from "./today-crawler.vue?vue&type=script&lang=js"
import style0 from "./today-crawler.vue?vue&type=style&index=0&id=0c8db79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8db79e",
  null
  
)

export default component.exports